import React, { useState } from "react";
import { adsAPI } from "../services/api";
import { formatPrice } from "../utils/helpers";

const uploadToCloudinary = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", "Yad2yad");
  const res  = await fetch("https://api.cloudinary.com/v1_1/dcmzkceqz/image/upload", { method:"POST", body: formData });
  const data = await res.json();
  return data.secure_url;
};

export default function Advertise() {
  const [form, setForm] = useState({
    business_name:"", contact_name:"", contact_email:"",
    contact_phone:"", description:"", website:"",
  });
  const [image, setImage]           = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [loading, setLoading]       = useState(false);
  const [success, setSuccess]       = useState(false);
  const [error, setError]           = useState("");

  const set = (key, val) => setForm(f => ({ ...f, [key]: val }));

  const handleImage = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setImage(file);
    setImagePreview(URL.createObjectURL(file));
  };

  const handleSubmit = async () => {
    setError("");
    if (!form.business_name.trim()) { setError("El nombre del negocio es obligatorio"); return; }
    if (!form.contact_name.trim())  { setError("El nombre de contacto es obligatorio"); return; }
    if (!form.contact_email.trim()) { setError("El email es obligatorio"); return; }
    if (!form.description.trim())   { setError("La descripcion es obligatoria"); return; }

    setLoading(true);
    try {
      let image_url = null;
      if (image) image_url = await uploadToCloudinary(image);
      await adsAPI.create({ ...form, image_url });
      setSuccess(true);
    } catch(e) {
      setError("Error al enviar el formulario. Intenta de nuevo.");
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div style={s.wrap}>
        <div style={s.successCard}>
          <div style={{fontSize:56,textAlign:"center"}}>🎉</div>
          <h2 style={s.successTitle}>Solicitud enviada!</h2>
          <p style={s.successText}>Recibimos tu solicitud. Te mandamos un mail para que crees tu contraseña y puedas seguir el estado de tu publicidad.</p>
          <p style={s.successText}>Los administradores la van a revisar, y una vez aceptada vas a poder pagar los <strong>{formatPrice(150000)}/mes</strong> para activarla.</p>
        </div>
      </div>
    );
  }

  return (
    <div style={s.page}>
      <div style={s.hero}>
        <h1 style={s.heroTitle}>Publica tu negocio en Yad2Yad</h1>
        <p style={s.heroSub}>Llega a toda la comunidad judia con tu publicidad</p>
        <div style={s.priceBox}>
          <p style={s.priceLabel}>Precio por mes</p>
          <p style={s.price}>{formatPrice(150000)}</p>
          <p style={s.priceSub}>30 dias de publicidad activa</p>
        </div>
      </div>

      <div style={s.benefits}>
        {[
          {icon:"👥",title:"Audiencia especifica",   text:"Llega a miembros verificados de la comunidad judia"},
          {icon:"📱",title:"Mobile y desktop",        text:"Tu publicidad se ve en celular y computadora"},
          {icon:"🔒",title:"Comunidad verificada",    text:"Todos los usuarios son miembros aprobados"},
          {icon:"💰",title:"Precio accesible",        text:"Solo $150.000 por mes de exposicion continua"},
        ].map(b => (
          <div key={b.title} style={s.benefit}>
            <span style={{fontSize:28}}>{b.icon}</span>
            <div>
              <p style={s.benefitTitle}>{b.title}</p>
              <p style={s.benefitText}>{b.text}</p>
            </div>
          </div>
        ))}
      </div>

      <div style={s.formWrap}>
        <h2 style={s.formTitle}>Completá el formulario</h2>

        <div style={s.section}>
          <label style={s.label}>Nombre del negocio *</label>
          <input style={s.input} value={form.business_name} onChange={e=>set("business_name",e.target.value)} placeholder="Ej: Panaderia Shalom" />
        </div>

        <div style={s.row2}>
          <div style={{flex:1}}>
            <label style={s.label}>Tu nombre *</label>
            <input style={s.input} value={form.contact_name} onChange={e=>set("contact_name",e.target.value)} placeholder="Nombre y apellido" />
          </div>
          <div style={{flex:1}}>
            <label style={s.label}>Telefono</label>
            <input style={s.input} type="tel" inputMode="numeric" value={form.contact_phone} onChange={e=>set("contact_phone",e.target.value.replace(/\D/g, ""))} placeholder="Ej: 1123456789" />
          </div>
        </div>

        <div style={s.section}>
          <label style={s.label}>Email de contacto *</label>
          <input style={s.input} type="email" value={form.contact_email} onChange={e=>set("contact_email",e.target.value)} placeholder="tu@email.com" />
        </div>

        <div style={s.section}>
          <label style={s.label}>Sitio web o Instagram (opcional)</label>
          <input style={s.input} value={form.website} onChange={e=>set("website",e.target.value)} placeholder="Ej: instagram.com/tunegocio" />
        </div>

        <div style={s.section}>
          <label style={s.label}>Descripcion del aviso *</label>
          <textarea style={s.textarea} rows={4} value={form.description} onChange={e=>set("description",e.target.value)} placeholder="Describe tu negocio o producto..." />
        </div>

        <div style={s.section}>
          <label style={s.label}>Logo o imagen (opcional)</label>
          <label style={s.uploadZone}>
            <input type="file" accept="image/*" style={{display:"none"}} onChange={handleImage} />
            {imagePreview
              ? <img src={imagePreview} alt="preview" style={{width:"100%",height:160,objectFit:"cover",borderRadius:8}} />
              : <div style={{textAlign:"center"}}><div style={{fontSize:32,marginBottom:8}}>🖼️</div><p style={{fontSize:13,color:"#1D9E75",fontWeight:500}}>Click para subir imagen</p><p style={{fontSize:11,color:"#aaa",marginTop:4}}>Recomendado 800x400px</p></div>
            }
          </label>
        </div>

        <div style={s.infoBox}>
          <p style={s.infoTitle}>💡 Como funciona</p>
          {["Completas este formulario","Los administradores revisan tu solicitud",`Te contactan para coordinar el pago de ${formatPrice(150000)}`, "Una vez confirmado, tu publicidad se activa por 30 dias"].map((t,i) => (
            <p key={i} style={s.infoText}>{i+1}. {t}</p>
          ))}
        </div>

        {error && <p style={s.error}>{error}</p>}

        <button style={{...s.btnSubmit,opacity:loading?0.7:1}} onClick={handleSubmit} disabled={loading}>
          {loading?"Enviando...":"Enviar solicitud de publicidad"}
        </button>
      </div>
    </div>
  );
}

const s = {
  page:{maxWidth:680,margin:"0 auto",padding:"0 0 40px"},
  wrap:{minHeight:"60vh",display:"flex",alignItems:"center",justifyContent:"center",padding:20},
  hero:{background:"linear-gradient(135deg,#1D9E75 0%,#0F6E56 100%)",padding:"48px 24px",textAlign:"center",color:"#fff"},
  heroTitle:{fontSize:"clamp(22px,4vw,32px)",fontWeight:700,marginBottom:8},
  heroSub:{fontSize:16,opacity:0.9,marginBottom:24},
  priceBox:{background:"rgba(255,255,255,0.15)",borderRadius:16,padding:"20px 32px",display:"inline-block"},
  priceLabel:{fontSize:13,opacity:0.8,marginBottom:4},
  price:{fontSize:36,fontWeight:700},
  priceSub:{fontSize:12,opacity:0.7,marginTop:4},
  benefits:{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))",gap:16,padding:"24px 20px"},
  benefit:{background:"#fff",border:"0.5px solid #e0e0e0",borderRadius:12,padding:"16px",display:"flex",gap:14,alignItems:"flex-start"},
  benefitTitle:{fontSize:14,fontWeight:600,color:"#111",marginBottom:4},
  benefitText:{fontSize:13,color:"#666",lineHeight:1.4},
  formWrap:{background:"#fff",border:"0.5px solid #e0e0e0",borderRadius:16,padding:"28px 24px",margin:"0 16px"},
  formTitle:{fontSize:20,fontWeight:600,marginBottom:20},
  section:{marginBottom:16},
  row2:{display:"flex",gap:12,marginBottom:16},
  label:{display:"block",fontSize:13,color:"#555",marginBottom:6,fontWeight:500},
  input:{width:"100%",padding:"10px 12px",borderRadius:8,border:"0.5px solid #ddd",fontSize:14},
  textarea:{width:"100%",padding:"10px 12px",borderRadius:8,border:"0.5px solid #ddd",fontSize:14,resize:"vertical"},
  uploadZone:{display:"block",border:"1.5px dashed #b0dcc9",borderRadius:10,padding:20,cursor:"pointer",overflow:"hidden"},
  infoBox:{background:"#f0faf6",border:"0.5px solid #b0dcc9",borderRadius:10,padding:"16px",marginBottom:20},
  infoTitle:{fontSize:14,fontWeight:600,color:"#0F6E56",marginBottom:10},
  infoText:{fontSize:13,color:"#555",marginBottom:4},
  error:{color:"#E24B4A",fontSize:13,marginBottom:12},
  btnSubmit:{width:"100%",background:"#1D9E75",color:"#fff",border:"none",borderRadius:10,padding:14,fontSize:15,fontWeight:600,cursor:"pointer"},
  successCard:{background:"#fff",borderRadius:16,padding:"36px 32px",maxWidth:440,width:"100%",boxShadow:"0 2px 16px rgba(0,0,0,0.06)",textAlign:"center",display:"flex",flexDirection:"column",gap:16},
  successTitle:{fontSize:22,fontWeight:600},
  successText:{fontSize:14,color:"#555",lineHeight:1.6},
};
